export enum ActionType {
  ON = "on",
  OFF = "off",
  GET_MENU = "get-menu",
  ADD_GLOBAL_ERROR = "add_global_error",
  REMOVE_GLOBAL_ERROR = "remove_global_error",
  CLEAR_GLOBAL_ERROR = "clear_global_error",
}
